import axios from 'axios';

class MitMerakiService {
  constructor() {}

  getOrganizations() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/meraki/admin/config/organizations')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  getNetworks(organizationId){
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/meraki/admin/config/networks/'+organizationId)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  getWifis(networkId){
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/meraki/admin/config/ssids/'+networkId)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  changePassword(newPassword, newPasswordConfirm) {
    return new Promise ((resolve, reject) => {

      if(newPassword !== newPasswordConfirm){
        return reject('New passwords do not match!');
      }

      axios.post('/api/v1/management/meraki/password/change', {
          newPassword:newPassword
        })
        .then((response) => {
            let result = response.data;
            return resolve(result);
        })
        .catch((error) => {
          let message = error.response.data;
          console.log("test "+message[0])
          if (Array.isArray(message) === false && typeof error.response.data != 'string') {
           message = 'Unknown server error';
          }
          
          return reject(message);
        });

    });
  }

  getPasswordValidation() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/meraki/password/validation')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  getPasswordGeneration() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/management/user/password/generate?numWords=6')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

}

export default new MitMerakiService();
